export default "__VITE_ASSET__Cbxe8dVO__"